import { useState } from "react";
import Lottie from "react-lottie-player";
import loadingLoop from "../assets/EazyRobo/StartAndLoading.json";
import startLoad from "../assets/EazyRobo/Loading.json";
import React from "react";
type Props = {
  size: number;
  isLoop: boolean;
};
export const EazyLoader = ({ size, isLoop }: Props) => {
  const [animation, setAnimation] = useState<any>(startLoad);
  const [loop, setLoop] = useState(false);
  return (
    <Lottie
      onComplete={() => {
        if (loadingLoop) setAnimation(loadingLoop);
        setLoop(isLoop);
      }}
      loop={loop}
      play={true}
      animationData={animation}
      style={{width:'60vh'}}
    />
  );
};
